import { setRecentIntroData } from '@wix/ambassador-funnel-intro-v1-intro-data/http'
import { IntroData } from '@wix/ambassador-funnel-intro-v1-intro-data/types'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'

export const saveRecentIntroData = async (introData: IntroData) => {
  const request = () => ambassadorHttpClient.request(setRecentIntroData({ introData }))
  await withMonitoring(request, 'saveRecentIntroData')
}
